import type {Item, SubmissionStatusGroup} from '@/api/items';
import type {PinterestPinStatus} from '@/api/pinterest';
import {buildPinterestPinMetadataFields} from '@/lib/pinterestItemMetadata';
import {DEFAULT_AFFILIATE, PLATFORM_ID} from '@/lib/platform';

/**
 The item a pasted Pinterest pin is submitted as. Built client-side, like the profile card's item: the
 pin lookup already holds everything the server needs, so no crawl has to finish first. Its
 content_type is what makes ClassifyDialog derive submission_type 'Content', and its external_id is
 the pin id - the key a pin submission is created, deduped and rechecked under (the pin's owner is a
 different, Actor, submission keyed on their own user id).
 */
export function buildPinItem(
  pin: PinterestPinStatus,
  submissionStatusGroups: SubmissionStatusGroup[]
): Item {
  const {owner} = pin;
  return {
    id: crypto.randomUUID(),
    external_id: pin.pin_id,
    platform: PLATFORM_ID,
    content_type: 'pin',
    title: pin.description?.trim().slice(0, 200) || `Pinterest Pin (${pin.pin_id})`,
    url: pin.url,
    thumbnail_url: pin.image_url,
    author_handle: owner.username,
    author_id: owner.user_id,
    author_name: owner.display_name,
    published_at: null,
    metadata: {Fields: buildPinterestPinMetadataFields(pin)},
    affiliate: DEFAULT_AFFILIATE,
    created_at: new Date().toISOString(),
    submission_status: null,
    submission_policy_violations: [],
    submission_status_groups: submissionStatusGroups,
    item_status: null,
    is_new_item: null
  };
}
